import React from 'react';
import { UseMutationResult } from '@tanstack/react-query';
import I18n from '@/modules/i18n';
import { StandardError } from '@/components/common/Modal';
import SessionPopup from '@/components/common/SessionPopup';
import Icon from '@/components/ui/Icon';

interface EndSessionModalProps {
  endMutation: UseMutationResult<unknown, unknown, void>;
  modalManager: ModalManager;
}

const EndSessionModal = ({ endMutation, modalManager }: EndSessionModalProps) => (
  <SessionPopup
    body={endMutation.isError ? <StandardError /> : I18n.t('end_session_body')}
    headline={{
      id: 'end-session-headline',
      text: I18n.t('end_session'),
    }}
    icon={<Icon color="tci-purple" icon="Stop" size={20} />}
    isOpen={modalManager.isOpen}
    primaryButton={{
      disabled: endMutation.isError,
      loading: endMutation.isLoading,
      onClick: () => endMutation.mutate(),
      text: I18n.t('end_session'),
      variant: 'red',
    }}
    secondaryButton={{
      onClick: modalManager.close,
      text: I18n.t('cancel'),
    }}
    onClose={modalManager.close}
  />
);

export default EndSessionModal;
